import { createFileRoute, Link } from '@tanstack/react-router';

export const Route = createFileRoute('/politica-cookie')({
  component: PoliticaCookiePage,
});

function PoliticaCookiePage() {
  return (
    <div className="min-h-screen bg-page-background p-6 md:p-10">
      <div className="mx-auto max-w-5xl rounded-lg border bg-card p-6 md:p-10">
        <header className="mb-8 space-y-2 border-b pb-6">
          <h1 className="text-3xl font-bold">ASSETO</h1>
          <p className="text-sm text-muted-foreground">
            Plataforma Interna de Gestao de Usuarios e Parceiros
          </p>
          <h2 className="text-xl font-semibold">Politica de Cookies</h2>
          <p className="text-sm text-muted-foreground">
            Versao: 1.0 | Vigencia: 01 de abril de 2026 | Publico: Usuarios internos e parceiros
            cadastrados
          </p>
        </header>

        <main className="space-y-8 text-sm leading-7">
          <section className="space-y-3">
            <h3 className="text-lg font-semibold">PARTE II - POLITICA DE COOKIES</h3>

            <h4 className="font-semibold">10. O Que Sao Cookies</h4>
            <p>
              Cookies sao pequenos arquivos de texto armazenados no navegador ou dispositivo do
              usuario ao acessar uma plataforma digital. Eles permitem que o sistema reconheca o
              usuario, mantenha sessoes ativas, registre preferencias e colete dados de uso para
              fins de seguranca e melhoria continua.
            </p>
            <p>
              Na plataforma interna do Asseto, os cookies sao utilizados exclusivamente para
              finalidades operacionais e de seguranca, nao sendo empregados para publicidade ou
              rastreamento de terceiros.
            </p>
          </section>

          <section className="space-y-3">
            <h4 className="font-semibold">11. Tipos de Cookies Utilizados</h4>
            <div className="overflow-x-auto rounded-md border">
              <table className="w-full border-collapse text-left">
                <thead>
                  <tr className="border-b bg-muted/50">
                    <th className="p-3 font-medium">Tipo de Cookie</th>
                    <th className="p-3 font-medium">Finalidade</th>
                    <th className="p-3 font-medium">Duracao</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b">
                    <td className="p-3">Cookies Essenciais</td>
                    <td className="p-3">
                      Necessarios para o funcionamento basico da plataforma: autenticacao,
                      manutencao de sessao e controle de acesso. Sem eles, o sistema nao funciona.
                    </td>
                    <td className="p-3">Sessao (ate o logout)</td>
                  </tr>
                  <tr className="border-b">
                    <td className="p-3">Cookies de Seguranca</td>
                    <td className="p-3">
                      Utilizados para detectar tentativas de acesso nao autorizado, fraudes e
                      atividades suspeitas. Incluem tokens CSRF e controles de sessao.
                    </td>
                    <td className="p-3">Sessao ou ate 2 a 4 horas</td>
                  </tr>
                  <tr className="border-b">
                    <td className="p-3">Cookies de Preferencias</td>
                    <td className="p-3">
                      Armazenam configuracoes do usuario, como idioma, fuso horario e preferencias
                      de interface, para personalizar a experiencia na plataforma.
                    </td>
                    <td className="p-3">Ate 30 dias</td>
                  </tr>
                  <tr>
                    <td className="p-3">Cookies Analiticos Internos</td>
                    <td className="p-3">
                      Coletam dados agregados e anonimos sobre navegacao e uso das funcionalidades,
                      utilizados para melhorar a plataforma. Nao identificam o usuario
                      individualmente.
                    </td>
                    <td className="p-3">Ate 90 dias</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p>
              Cookies de terceiros para fins de marketing, publicidade ou rastreamento externo nao
              sao utilizados nesta plataforma.
            </p>
          </section>

          <section className="space-y-3">
            <h4 className="font-semibold">12. Gerenciamento e Controle de Cookies</h4>
            <p>
              Por se tratar de uma plataforma interna de uso corporativo, os cookies essenciais e
              de seguranca sao obrigatorios para o funcionamento da plataforma e nao podem ser
              desativados sem comprometer o acesso ao sistema.
            </p>
            <p>
              Os cookies de preferencias e analiticos internos podem ser gerenciados nas
              configuracoes de perfil do usuario dentro da propria plataforma. Alem disso, os
              navegadores modernos permitem configurar, bloquear ou excluir cookies:
            </p>
            <ul className="list-disc space-y-1 pl-6">
              <li>Google Chrome: Configuracoes &gt; Privacidade e seguranca &gt; Cookies</li>
              <li>Mozilla Firefox: Opcoes &gt; Privacidade e Seguranca &gt; Cookies</li>
              <li>
                Microsoft Edge: Configuracoes &gt; Privacidade, pesquisa e servicos
              </li>
              <li>Safari: Preferencias &gt; Privacidade &gt; Gerenciar dados do site</li>
            </ul>
            <p>
              Atencao: a desativacao de cookies essenciais impede o acesso a plataforma, pois e
              necessaria para autenticacao e controle de sessao.
            </p>
          </section>

          <section className="space-y-3">
            <h4 className="font-semibold">13. Armazenamento Local e Tecnologias Similares</h4>
            <p>
              Alem de cookies, a plataforma pode utilizar tecnologias de armazenamento local no
              navegador (localStorage e sessionStorage) para:
            </p>
            <ul className="list-disc space-y-1 pl-6">
              <li>Manter o estado da aplicacao durante a navegacao (ex.: dados de formularios)</li>
              <li>Armazenar tokens de autenticacao de forma temporaria</li>
              <li>Otimizar o desempenho com cache de dados nao sensiveis</li>
            </ul>
            <p>
              Esses dados sao tratados com o mesmo nivel de protecao aplicado aos cookies e nao sao
              compartilhados com terceiros.
            </p>
          </section>

          <section className="space-y-3 border-t pt-6">
            <h3 className="text-lg font-semibold">PARTE III - DISPOSICOES GERAIS</h3>

            <h4 className="font-semibold">14. Atualizacoes desta Politica</h4>
            <p>
              Esta politica pode ser atualizada periodicamente para refletir mudancas nos processos
              internos, na legislacao aplicavel ou nas funcionalidades da plataforma. Alteracoes
              relevantes serao comunicadas aos usuarios por meio de notificacao dentro da propria
              plataforma e/ou por e-mail corporativo, com antecedencia minima de 15 dias uteis. A
              versao vigente estara sempre disponivel na plataforma, com a data da ultima
              atualizacao indicada no cabecalho deste documento.
            </p>

            <h4 className="font-semibold">15. Legislacao e Foro Aplicaveis</h4>
            <p>
              Esta politica e regida pela legislacao brasileira, em especial pela Lei Geral de
              Protecao de Dados (Lei n.o 13.709/2018 - LGPD) e demais normas aplicaveis. Qualquer
              controversia decorrente desta politica sera submetida ao foro da comarca de Belem,
              Estado do Para, com exclusao de qualquer outro, por mais privilegiado que seja.
            </p>

            <h4 className="font-semibold">16. Canal de Contato e DPO</h4>
            <p>
              Para exercicio de direitos, esclarecimentos, reclamacoes ou qualquer comunicacao
              relacionada a privacidade e protecao de dados, o titular pode contatar o Encarregado
              de Protecao de Dados (DPO) do Asseto:
            </p>
            <p>
              DPO - Encarregado de Protecao de Dados | Asseto
              <br />
              E-mail: contato@digitalfluxo.com
              <br />
              Horario de atendimento: segunda a sexta, das 9h as 18h (horario de Brasilia)
              <br />
              Prazo de resposta: ate 15 dias uteis a contar do recebimento da solicitacao
            </p>
          </section>
        </main>

        <footer className="mt-10 border-t pt-6 text-sm text-muted-foreground">
          <p>Asseto - Plataforma Interna de Gestao de Usuarios e Parceiros</p>
          <p>Vigencia: 01 de abril de 2026 | Versao 1.0</p>
          <div className="mt-4">
            <Link to="/politica-privacidade" className="underline">
              Ver Politica de Privacidade
            </Link>
          </div>
        </footer>
      </div>
    </div>
  );
}
